<script>
  import { isEnglish } from "../stores/cookies.js"; // assuming it's a readable store
  import { push } from "svelte-spa-router";
  export let image;
  export let title;
  export let text;
  export let number = null; // optional phone number
  export let link = null; // optional page link
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<svelte:element
  this="div"
  href={link || undefined}
  class="relative group block bg-blue-50 rounded-xl p-6 pt-16 shadow-md max-w-sm mx-auto
         transition-all duration-200"
  class:cursor-pointer={link || number}
  class:hover:bg-blue-50={link}
  class:no-underline={link}
  class:hover:no-underline={link}
  on:click={!link && number
    ? () => (window.location.href = `tel:${number.replace(/\s+/g, "")}`)
    : () => {
        push("/services");
        setTimeout(
          () =>
            document
              .getElementById(link)
              ?.scrollIntoView({ behavior: "smooth", block: "start" }),
          120,
        );
      }}
>
  <!-- Circle image badge -->
  <div class="absolute -top-10 left-1/2 -translate-x-1/2">
    <div
      class="w-24 h-24 bg-blue-600 rounded-full flex items-center justify-center overflow-hidden shadow-lg"
    >
      <!-- svelte-ignore a11y-img-redundant-alt -->
      <img src={image} alt="card image" class="w-16 h-16 object-contain" />
    </div>
  </div>

  <!-- Title -->
  <h2
    class="text-center text-2xl font-bold text-black mt-4 transition-colors duration-200
           group-hover:text-blue-600"
  >
    {title}
  </h2>

  <!-- Body text -->
  <p
    class="text-center text-lg text-black mt-2 transition-colors duration-200
           group-hover:text-blue-600"
  >
    {@html text}
  </p>

  <!-- Phone number (clickable when no link, hover style always via group) -->
  {#if number}
    <h2
      class="text-center text-2xl font-bold mt-4 transition-all duration-200 text-black
             decoration-transparent group-hover:decoration-blue-600
             group-hover:text-blue-600 group-hover:underline underline-offset-4"
    >
      {number}
    </h2>
  {/if}

  <!-- See More / Sien Nog -->
  {#if link}
    <div class="text-center mt-4">
      <span
        class="text-blue-600 font-semibold underline decoration-blue-600/70
               group-hover:text-blue-700 group-hover:decoration-blue-700"
      >
        {$isEnglish ? "See More →" : "Sien Nog →"}
      </span>
    </div>
  {/if}
</svelte:element>
